import { TMP_ELEMENT_POSITION, TMP_ELEMENT_SIZE } from '../../shared/abstract-boxes';
import { getConfirmConfigurationOption } from './confirmConfiguration';

export const ALWAYS_LAST_ANSWER_TYPES = ['user-input', 'next-box-by-default'];


export function ConfirmBoxViewConstructor(services, callbacks, context, siteTypeConfig) {

  let joint = services.joint;

  return joint.shapes.html.AbstractBoxElementWithDragAndDropView.extend({
    isElementEditable: true,
    editElementModalController: 'editConfirmTextController',
    editElementModalTemplate: require('./editConfirmText.modal.html'),
    angularTemplate: require('./ConfirmBoxView.html'),

    initialize: function () {
      joint.shapes.html.AbstractBoxElementView.prototype.initialize.apply(this, arguments);
    },

    getText: function () {
      return this.angularScope.elementData ? this.angularScope.elementData.text : null;
    },

    addConfirmButton: function (id) {
      let button = this.createConfirmButton(id);
      this.model.embed(button);
      this.model.graph.addCell(button);
    },

    createConfirmButton: function (id,
      position = TMP_ELEMENT_POSITION,
      size = TMP_ELEMENT_SIZE,
      elementData = null) {
      if (!elementData) {
        elementData = { type: 'postback' };
      }
      let button = new joint.shapes.html.ConfirmButton({ id, position, size, elementData });

      return button;
    },

    getConfigurationOption: function (key) {
      return getConfirmConfigurationOption(key);
    },

  });
}
